'use client';
import Script from 'next/script';

const GoogleAnalytics = ({
    cookieConsent,
    nonce,
}: {
    cookieConsent: string;
    nonce: string;
}) => {
    return (
        <>
            <Script
                dangerouslySetInnerHTML={{
                    __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('consent', 'default', {
                      'ad_storage': 'denied',
                      'ad_user_data': 'denied',
                      'ad_personalization': 'denied',
                      'analytics_storage': 'denied'
                    });
                  `,
                }}
                id="google-analytics-consent-default"
                nonce={nonce}
            />

            {cookieConsent === 'true' && (
                <>
                    <Script
                        async
                        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}`}
                    />
                    <Script
                        dangerouslySetInnerHTML={{
                            __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}');
                  `,
                        }}
                        id="google-analytics"
                        nonce={nonce}
                    />
                </>
            )}
        </>
    );
};

export default GoogleAnalytics;
